module.exports = __webpack_public_path__ + "img/close.75f1be59.svg";